/**
 * Shared transformation utilities for strategy configurations
 */

/**
 * Transform criteria inputs for API submission:
 * - Converts `this_site` type to `this_provider` with `ui_key: 'this_site'`
 * - Strips `ui_metadata` (used only for UI hydration, backend provides its own)
 */
export const transformCriteriaInputs = (
  inputs: Record<string, any> | undefined | null
): Record<string, any> => {
  if (!inputs) return {};

  const transformed: Record<string, any> = {};

  Object.entries(inputs).forEach(([key, value]: [string, any]) => {
    // Strip ui_metadata — it's only needed client-side during editing
    const { ui_metadata, ...rest } = value || {};

    if (rest?.type === 'this_site') {
      // Transform this_site to this_provider for the API
      transformed[key] = {
        ...rest,
        type: 'this_provider',
        ui_key: 'this_site',
      };
    } else {
      transformed[key] = rest;
    }
  });

  return transformed;
};
